module.exports = __webpack_public_path__ + "img/131.2.c0aa955f.png";